import { User } from '../../../../../@types/User';
import api from '../../../../../services/api/api';
import { LoginInput, LoginResponse } from './interface';

export const authenticate = async (props: LoginInput) => {
  const { data } = await api.post<LoginResponse>('/auth/agent', {
    ...props,
  });

  return data;
};

export const visitorAuthenticate = async () => {
  const { data } = await api.post<LoginResponse>('/auth/workshop', {
    email: 'visitante@hotmail.com',
    password: '123456',
  });

  return data;
};
